import Image from 'next/image'
import Link from 'next/link'
import { useLocale } from 'next-intl'

interface LogoProps {
  variant?: 'header' | 'footer' | 'mobile'
  showText?: boolean
  className?: string
}

export default function Logo({ variant = 'header', showText = false, className = '' }: LogoProps) {
  const locale = useLocale()
  
  // Tailles optimisées pour le logo personnalisé
  const sizes = {
    header: { width: 160, height: 50 },   // Logo complet pour header
    footer: { width: 120, height: 38 },   // Version footer
    mobile: { width: 140, height: 44 }    // Version mobile
  }
  
  const currentSize = sizes[variant]
  
  return (
    <Link 
      href={`/${locale}`} 
      className={`flex items-center gap-3 ${className}`}
      prefetch
    >
      {/* Logo Msintapujo */}
      <Image
        src="/images/logo/MSinTpersonalizado.png"
        alt="MSinTapujos Logo"
        width={currentSize.width}
        height={currentSize.height}
        priority={variant === 'header'}
        className="h-auto w-auto"
      />
      
      {/* Texte du logo */}
      {showText && (
        <span className={`font-extrabold tracking-tight ${
          variant === 'header' ? 'text-xl' : 
          variant === 'footer' ? 'text-lg' : 
          'text-lg'
        }`}>
          MSinTapujos
        </span>
      )}
      

    </Link>
  )
}